import React, { useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles, withStyles, Theme, createStyles } from '@material-ui/core/styles';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem, { TreeItemProps } from '@material-ui/lab/TreeItem';
import Collapse from '@material-ui/core/Collapse';
import { useSpring, animated } from 'react-spring/web.cjs';
import { TransitionProps } from '@material-ui/core/transitions';
import { Box, SvgIcon, SvgIconProps } from "@material-ui/core";
import { MenuData, MenuTextData } from "../models/types";
import { ApplicationState } from "../store";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { Link } from "react-router-dom";
import { saveTreeState } from "./../store/menu/action";


const StyledTreeItem = withStyles((theme: Theme) =>
    createStyles({
        iconContainer: {
            '& .close': {
                opacity: 0.3,
            },
        },
        group: {
            marginLeft: 7,
            paddingLeft: 18,
        },
        label: {
            fontSize: '13px',
            lineHeight: 1.35,
        }
    }),
)((props: TreeItemProps) => <TreeItem {...props} TransitionComponent={TransitionComponent} />);

const useStyles = makeStyles(
    createStyles({
        root: {
            flexGrow: 1,
            maxWidth: 300,
        },
        link: {
            color: "#000000",
            textDecoration: "none",
        },
        box: {
            border: '1px solid #ebdcc6',
            borderRadius: '6px',
            paddingTop: '15px',
            maxWidth: '90%',
            boxShadow: 'none',
        }
    }),
);

function MinusSquare(props: SvgIconProps) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
        </SvgIcon>
    );
}

function PlusSquare(props: SvgIconProps) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
        </SvgIcon>
    );
}

function TransitionComponent(props: TransitionProps) {
    const style = useSpring({
        from: { opacity: 0, transform: 'translate3d(20px,0,0)' },
        to: { opacity: props.in ? 1 : 0, transform: `translate3d(${props.in ? 0 : 20}px,0,0)` },
    });

    return (
        <animated.div style={style}>
            <Collapse {...props} />
        </animated.div>
    );
}

interface IProps {
    categoryId?: string
  }
  
interface PropsFromState {
    language: string;
    loading: boolean;
    errors?: string;
    menu: MenuData[];
    text: MenuTextData;
    treeState: string[];
}

interface propsFromDispatch {
    saveTreeState: (treeState: string[]) => any;
}

type AllProps = PropsFromState & propsFromDispatch & IProps;

const ProductTree: React.FC<AllProps> = ({
    language,
    loading,
    menu,
    text,
    treeState,
    saveTreeState
}) => {
    useEffect(() => {
    }, []);

    const onNodeToggle = (nodeId: any, isExpanded: string[]) => {
        saveTreeState(isExpanded);
    };

    const classes = useStyles();

    const renderTree = (menu: MenuData, text: MenuTextData, language: string) => (
        (Array.isArray(menu.children) && menu.children?.length) ? (
            <StyledTreeItem key={menu.code} nodeId={menu.code} label={text[menu.code]?.value[language]}>
                {Array.isArray(menu.children) ? menu.children.map((menu) => renderTree(menu, text, language)) : null}
            </StyledTreeItem>
        ) : (
                <Link to={"/product/category/" + menu.code} className={classes.link}>
                    <StyledTreeItem key={menu.code} nodeId={menu.code} label={text[menu.code]?.value[language]} />
                </Link>
            )
    );

    return (
        <>
            { !loading ? (
                <Box pl={2} pb={2} className={classes.box}>
                    <TreeView
                        className={classes.root}
                        expanded={treeState}
                        onNodeToggle={onNodeToggle}
                        defaultCollapseIcon={<MinusSquare />}
                        defaultExpandIcon={<PlusSquare />}
                    >
                        {menu.map(codes => (renderTree(codes, text, language)))}
                    </TreeView>
                </Box>
            ) : (
                    null
                )}
        </>
    );
};

const mapStateToProps = ({ language, menu }: ApplicationState) => ({
    language: language.language,
    loading: menu.loading,
    errors: menu.errors,
    menu: menu.menu,
    text: menu.text,
    treeState: menu.treeState
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {
        saveTreeState: (treeState: string[]) => {
          dispatch(saveTreeState(treeState));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductTree);
